import React, { Component } from "react";
import { Alert } from "reactstrap";
import { injectIntl, defineMessages } from "react-intl";
import SupportModal from "./SupportModal";
import Card from "../components/Card";
import { orderNodes } from "../Utils/SupportUtils";

const messages = defineMessages({
  title: {
    id: "Main.title",
    defaultMessage: "Please start choose an option to contact us",
  },
  errorMessage: {
    id: "Main.errorMessage",
    defaultMessage: "Something went wrong!",
  },
});
class Main extends Component {
  state = {
    allNodes: [],
    modalOpen: false,
    firstNodeSelected: null,
  };

  toggleModal = (node, isLeaf, historyNodes) => {
    const filteredNodes = node
      ? this.props.allNodes.filter((el) => el.parentnodeid === node.nodeid)
      : null;

    if (filteredNodes && !filteredNodes.length) {
      this.props.saveNodeData(node, historyNodes);
    } else {
      if (!node && !isLeaf) {
        this.setState({
          ...this.state,
          modalOpen: false,
          firstNodeSelected: null,
        });
      } else {
        this.setState({
          ...this.state,
          modalOpen: !this.state.modalOpen,
          firstNodeSelected: isLeaf ? this.state.firstNodeSelected : node,
        });
      }
    }
  };

  render() {
    const { firstNodeSelected, modalOpen } = this.state;
    const {
      allNodes,
      getTreeNodesError,
      iconStyle,
      bodyStyle,
      modalStyle,
      intl: { formatMessage },
    } = this.props;

    const firstLevelNodes = allNodes
      .filter((node) => node.parentnodeid === null)
      .sort(orderNodes);

    return (
      <div className="container  pt-5" style={{ minHeight: "300px" }}>
        <h2
          className="text-center"
          style={{ color: bodyStyle && bodyStyle.color, fontWeight: 300 }}
        >
          {formatMessage(messages.title)}
        </h2>
        <div className="row justify-content-center">
          {firstLevelNodes.map((node) => {
            return (
              <Card
                key={node.nodeid}
                node={node}
                iconStyle={iconStyle}
                bodyStyle={bodyStyle}
                selectHandler={() => this.toggleModal(node)}
                className="col-md-3 col-sm-4 m-4"
              />
            );
          })}
          <SupportModal
            isOpen={modalOpen}
            toggle={this.toggleModal}
            firstNodeSelected={firstNodeSelected}
            allNodes={allNodes}
            styleElements={{ iconStyle, bodyStyle, modalStyle }}
          />
        </div>
        <div className="row justify-content-center">
          <Alert color="danger" isOpen={getTreeNodesError}>
            {formatMessage(messages.errorMessage)}
          </Alert>
        </div>
      </div>
    );
  }
}

export default injectIntl(Main);
